import { createFileRoute } from '@tanstack/react-router'
import StaffLogin from '@/pages/StaffLogin'

export const Route = createFileRoute('/staff-login')({
  component: StaffLogin,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      restaurant: search['restaurant'] as string | undefined,
    }
  },
})
